// extracted by mini-css-extract-plugin
export default {"shareButton":"ShareButtons_shareButton__TkzZF"};